import React from 'react'
import GeneralButton from '../../../../components/kit/GeneralButton/GeneralButton'
import InputForm from '../../../../components/kit/InputForm/InputForm'
import { checkEmptyField } from '../../../../global/Helpers/checkEmptyField'
import { logoWidth } from "../../../../constants.json";
import Logotype from "../../../../components/kit/Logo/Logotype";
import '../index.scss'

const GetResultForm = ({
  handleClickNext,
  orderNumber,
  codeword,
  download,
  inputChangeHandler,
}) => {
    const disabled =
    !checkEmptyField(orderNumber) ||
    !checkEmptyField(codeword)
  return (
    <div className="get-result">
      <div className={'get-result__logo'}>
        <Logotype width={logoWidth} />
      </div>
      <div className="get-result__title title">Результаты</div>
      <form className="get-result__form">
        <InputForm
          className="get-result__field"
          type="text"
          value={orderNumber}
          propertyName="orderNumber"
          onChange={inputChangeHandler}
          label="Номер заказа"
        />
        <InputForm
          className="get-result__field"
          type="text"
          value={codeword}
          propertyName="codeword"
          onChange={inputChangeHandler}
          label="Кодовое слово"
        />
      </form>
      <div className="d-flex mt-30">
        <GeneralButton className="mr-10" title="Назад" onClick={handleClickNext}/>
        <GeneralButton title="Скачать бланк" onClick={download} disabled={disabled}/>
      </div>
    </div>
  )
}

export default GetResultForm
